import Vue from 'vue';
import querystring from 'querystring';
import * as Pedidos from '@lib/Ventas/Pedidos';
import { Pedido } from '@lib/Ventas/Pedidos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { ResumenPedidos } from '@/__env/lib/Ventas/Pedidos/Resumen';
import { Transporte } from '@/__env/lib/Expedicion/Transportes';
import Axios from 'axios';


export class ControladorSeccion {
    constructor () {
        this.Estadistica = new ResumenEstadisticas( this );
    }

    public readonly Estadistica: ResumenEstadisticas;
    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Pedido[] = [];
    FacturarTodo ( x: Pedido[] ) {

    }

    Iniciar () {
        this.Buscador.Iniciar();
    }


    Abrir ( x: Pedido ) {
        if ( x && x.Existe ) {
            router.push( '/pedido/' + x.Id );
        }
    }

    AbrirEnOtraPestaña ( x: Pedido ) {
        if ( x && x.Existe ) {
            window.open( '/#/pedido/' + x.Id );
        }
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados () { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica () {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica = new SignalDispatcher();
    public get onRecargarEstadistica () { return this._onRecargarEstadistica.asEvent(); }

    public BuscandoPendientesMLA = false;
    public PendientesMla = 0;
    async BuscarPendientes () {
        this.BuscandoPendientesMLA = true;
        const data = await Pedido.PendientesMla();
        if ( data && data.orders >= 0 ) {
            this.PendientesMla = data.orders;
        }
        else {
            this.PendientesMla = null;
        }

        this.BuscandoPendientesMLA = false;

    }
}

export class Vista extends VistaBase {
    public Filtros: FiltrosBase = new FiltrosBase();

}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador {

    public Items: Pedido[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar () {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado (): Estado { return this.estado; }
    set Estado ( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado () { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar () { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar ( pagina: number = null, agregar: boolean = false ) {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        if ( !agregar ) {
            this.Items.clear();
            this.Estado = 'cargando';
        }

        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        //ff.details = 'costos_envio';
        let e = await Pedido.find( ff );
        if ( e.Error ) {
            this.Estado = 'error';
        }
        else {
            if ( !agregar ) {
                this.Items = e.Items;
            } else {
                this.Items.push( ...e.Items );
            }

            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros {
    constructor ( b: Buscador ) {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';
    public BusquedaProvincia: string = '';
    public BusquedaArticulo: string = '';

    public Valores: Record<string, any> = {
        Estado: 0,
        Tipo: 0,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        Logistica: '',
        Cliente: '',
        HojaPiso: '',
    };


    public get Estados () { return Pedidos.Estados.Filter; }
    public get Tipos () { return Pedidos.Tipos.Filter; }
    public get Cuentas () { return [...CuentasMercadoLibre]; }
    public get Limites () { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes () { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices () { return [{ Nombre: 'Fecha del pedido', Id: 'fecha' }, { Nombre: 'Id externa', Id: 'id_externa' }, { Nombre: 'Número de pedido', Id: 'id' }, { Nombre: 'Importe', Id: 'importe_final_con_envio' }]; }
    public get Tags () {
        return [
            { Nombre: 'Todos', Id: '' },
            { Nombre: 'Para preparar', Id: 'pendientes', Valor: 'pendientes' },
            { Nombre: 'Demorados', Id: 'demorados', Valor: 'demorados' },
            { Nombre: 'Despachar hoy', Id: 'despachar-hoy', Valor: 'despachar-hoy' },
            { Nombre: 'Envio no acordado', Id: 'envio-no-acordado', Valor: 'envio-no-acordado' },
            { Nombre: 'MercadoEnvios', Id: 'mercado-envios', Valor: 'mercado-envios' },
            { Nombre: 'MercadoEnvios Flex', Id: 'mercado-envios-flex', Valor: 'mercado-envios-flex' },
            { Nombre: 'MercadoEnvios Full', Id: 'mercado-envios-full', Valor: 'mercado-envios-full' },
            { Nombre: 'Retira cliente', Id: 'retira-cliente', Valor: 'retira-cliente' },
            { Nombre: 'Envio gratis', Id: 'envio-gratis', Valor: 'envio-gratis' },
            { Nombre: 'Envio propio', Id: 'envio-propio', Valor: 'envio-propio' },
            { Nombre: 'Contraentrega', Id: 'contra-entrega', Valor: 'contra-entrega' },

            { Nombre: 'Preparando', Id: 'preparando', Valor: 'preparando' },
            { Nombre: 'Facturados', Id: 'facturados', Valor: 'facturados' },
            { Nombre: 'No Facturados', Id: 'no_facturados', Valor: 'no_facturados' },
            { Nombre: 'Preparando - Demorados', Id: 'preparando-demorados', Valor: 'preparando-demorados' },
            { Nombre: 'Preparando - Despachar hoy', Id: 'preparando-despachar-hoy', Valor: 'preparando-despachar-hoy' },
            { Nombre: 'Preparando - Envio no acordado', Id: 'preparando-envio-no-acordado', Valor: 'preparando-envio-no-acordado' },
            { Nombre: 'Preparando - MercadoEnvios', Id: 'preparando-mercado-envios', Valor: 'preparando-mercado-envios' },
            { Nombre: 'Preparando - MercadoEnvios Flex', Id: 'preparando-mercado-envios-flex', Valor: 'preparando-mercado-envios-flex' },
            { Nombre: 'Preparando - MercadoEnvios Full', Id: 'preparando-mercado-envios-full', Valor: 'preparando-mercado-envios-full' },
            { Nombre: 'Preparando - Retira cliente', Id: 'preparando-retira-cliente', Valor: 'preparando-retira-cliente' },
            { Nombre: 'Preparando - Envio gratis', Id: 'preparando-envio-gratis', Valor: 'preparando-envio-gratis' },
            { Nombre: 'Preparando - Envio propio', Id: 'preparando-envio-propio', Valor: 'preparando-envio-propio' },
            { Nombre: 'Preparando - Contraentrega', Id: 'preparando-contra-entrega', Valor: 'preparando-contra-entrega' },

            { Nombre: 'Despachados', Id: 'despachados', Valor: 'despachados' },
            { Nombre: 'Devueltos', Id: 'devueltos', Valor: 'devueltos' },

            { Nombre: 'Finalizados', Id: 'finalizados', Valor: 'finalizados' },
            { Nombre: 'Pendientes MLA', Id: 'pendientes_mla', Valor: 'pendientes_mla' },

        ];
    }

    public get esSoloMercadoLibre (): boolean { return Pedidos.Tipos.Filter[this.Valores.Tipo] && Pedidos.Tipos.Filter[this.Valores.Tipo].Valor.map( x => x.Id ).includes( 'mercado-libre' ); }
    public get Activos (): { Nombre: string, Eliminar: any; }[] {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.BusquedaProvincia ) {
            a.push( { Nombre: `Provincia o Localidad: ${ this.BusquedaProvincia }`, Eliminar: () => { this.BusquedaProvincia = ''; this.Buscador.Buscar(); } } );
        }

        if ( this.BusquedaArticulo ) {
            a.push( { Nombre: `Articulo: ${ this.BusquedaArticulo }`, Eliminar: () => { this.BusquedaArticulo = ''; this.Buscador.Buscar(); } } );
        }

        if ( this.Busqueda ) {
            a.push( { Nombre: `Resultados para: ${ this.Busqueda }`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else {

            if ( this.Valores.Estado > 0 ) {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Logistica ) {
                a.push( { Nombre: this.Valores.Logistica.Descripcion, Eliminar: () => { this.Valores.Logistica = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Cliente ) {
                a.push( { Nombre: this.Valores.Cliente.Vista.Descripcion, Eliminar: () => { this.Valores.Cliente = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.HojaPiso ) {
                a.push( { Nombre: 'Hoja de piso Nº ' + this.Valores.HojaPiso, Eliminar: () => { this.Valores.HojaPiso = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tag > 0 ) {
                a.push( { Nombre: this.Tags[this.Valores.Tag].Nombre, Eliminar: () => { this.Valores.Tag = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tipo > 0 ) {
                a.push( { Nombre: this.Tipos[this.Valores.Tipo].Nombre, Eliminar: () => { this.Valores.Tipo = 0; this.Buscador.Buscar(); } } );
                if ( this.Valores.Tipo == 1 && this.Valores.Cuenta ) {
                    a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
                }
            }
        }

        return a;
    }

    public Obtener (): any {
        let filtro: any = {};
        filtro.busqueda = 'S';

        if ( this.BusquedaProvincia ) {
            filtro.q_direccion = this.BusquedaProvincia;
        }

        if ( this.BusquedaArticulo ) {
            filtro.q_articulo = this.BusquedaArticulo;
        }

        if ( this.Busqueda ) {
            filtro.q = this.Busqueda;
        }
        else {

            if ( this.Valores.Estado > 0 ) {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Tag > 0 ) {
                filtro.tags = this.Tags[this.Valores.Tag].Id;
            }

            if ( this.Valores.Logistica ) {
                filtro.logistica = this.Valores.Logistica.Codigo;
            }

            if ( this.Valores.Cliente ) {
                filtro.cliente = this.Valores.Cliente.Id;
            }

            if ( this.Valores.HojaPiso ) {
                filtro.hoja_piso = this.Valores.HojaPiso;
            }

            if ( this.Valores.Tipo > 0 ) {
                filtro.tipo = this.Tipos[this.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );

                if ( this.Valores.Tipo == 1 && this.Valores.Cuenta > 0 ) {
                    filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
                }

            }

        }

        if ( this.Valores.Limite >= 0 ) {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 ) {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 ) {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 ) {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set ( filtro: any ) {

        if ( filtro.q_direccion ) {
            this.BusquedaProvincia = String( filtro.q_direccion );
        }

        if ( filtro.q_articulo ) {
            this.BusquedaArticulo = String( filtro.q_articulo );
        }

        if ( filtro.q ) {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado ) {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.estado ) {
            this.Valores.Tag = 0;
            let idx = this.Tags.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.tag );
            if ( idx > 0 ) this.Valores.Tag = idx;
        }

        if ( filtro.tipo ) {
            this.Valores.Tipo = 0;
            let idx = this.Tipos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo );
            if ( idx > 0 ) this.Valores.Tipo = idx;

            if ( this.Valores.Tipo == 1 && filtro.cuenta ) {
                this.Valores.Cuenta = 0;
                let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
                if ( idx > 0 ) this.Valores.Cuenta = idx;
            }
        }

        if ( filtro.limit ) {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort ) {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order ) {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 ) {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get (): string {
        let filtro: any = {};
        if ( this.BusquedaProvincia ) {
            filtro.q_direccion = this.BusquedaProvincia;
        }

        if ( this.BusquedaArticulo ) {
            filtro.q_articulo = this.BusquedaArticulo;
        }

        if ( this.Busqueda ) {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 ) {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tag > 0 ) {
            filtro.tag = this.Tags[this.Valores.Tag].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Logistica ) {
            filtro.logistica = this.Valores.Logistica.Descripcion.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cliente ) {
            filtro.cliente = this.Valores.Cliente.Vista.Descripcion.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.HojaPiso ) {
            filtro.hoja_piso = this.Valores.HojaPiso;
        }

        if ( this.Valores.Tipo > 0 ) {
            filtro.tipo = this.Tipos[this.Valores.Tipo].Nombre.eliminar( ' ' ).toLowerCase();

            if ( this.Valores.Cuenta ) {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }
        }

        if ( this.Valores.Limite >= 0 ) {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 ) {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 ) {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 ) {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}



export class ResumenEstadisticas {
    constructor ( cont: ControladorSeccion ) {
        this.Controlador = cont;
    }
    public Controlador: ControladorSeccion;
    public EstadoSeleccionado: string = '-';
    public Estadistica: ResumenPedidos = new ResumenPedidos();
    public Valores: any = [{}, {}, {}, {},];

    async Iniciar ( forzar: boolean = false ) {
        if ( !forzar && this.EstadoSeleccionado == this.Controlador.Buscador.Filtros.Tipos[this.Controlador.Buscador.Filtros.Valores.Tipo].Valor.map( x => x.Id ).join( ',' ) ) {
            return;
        }

        this.EstadoSeleccionado = this.Controlador.Buscador.Filtros.Tipos[this.Controlador.Buscador.Filtros.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );
        this.Estadistica = await ResumenPedidos.create( this.EstadoSeleccionado );

        this.Valores.clear();
        let pendientes: any = {
            Titulo: 'Para preparar',
            Valor: this.Estadistica.Datos.pendientes.total,
            Importe: this.Estadistica.Datos.pendientes.importe,
            Problema: this.Estadistica.Datos.pendientes.detalles.demorados > 0,
            Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'pendientes' ); this.Controlador.Buscador.Buscar( 1 ); },
            Transportes: [],
            Opciones: [
                {
                    Titulo: 'Demorados',
                    Valor: this.Estadistica.Datos.pendientes.detalles.demorados,
                    Problema: this.Estadistica.Datos.pendientes.detalles.demorados > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'demorados' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Despachar hoy',
                    Valor: this.Estadistica.Datos.pendientes.detalles['despachar-hoy'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'despachar-hoy' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envio no acordado',
                    Valor: this.Estadistica.Datos.pendientes.detalles['envio-no-acordado'],
                    Problema: this.Estadistica.Datos.pendientes.detalles['envio-no-acordado'] > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'envio-no-acordado' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'MercadoEnvios',
                    Valor: this.Estadistica.Datos.pendientes.detalles['mercado-envios'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'mercado-envios' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'MercadoEnvios Flex',
                    Valor: this.Estadistica.Datos.pendientes.detalles['mercado-envios-flex'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'mercado-envios-flex' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'MercadoEnvios Full',
                    Valor: this.Estadistica.Datos.pendientes.detalles['mercado-envios-full'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'mercado-envios-full' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envio gratis',
                    Valor: this.Estadistica.Datos.pendientes.detalles['envio-gratis'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'envio-gratis' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envios propios',
                    Valor: this.Estadistica.Datos.pendientes.detalles['envio-propio'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'envio-propio' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Contraentregas',
                    Valor: this.Estadistica.Datos.pendientes.detalles['contra-entrega'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'contra-entrega' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Retira cliente',
                    Valor: this.Estadistica.Datos.pendientes.detalles['retira-cliente'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'retira-cliente' ); this.Controlador.Buscador.Buscar( 1 ); },
                }
            ]


        };

        if ( this.Estadistica.Datos.pendientes.transportes )
            for ( let trp of this.Estadistica.Datos.pendientes.transportes ) {
                pendientes.Transportes.push(
                    {
                        Empresa: new Transporte( trp ),
                        Valor: trp.total,
                        Accion: () => {
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'pendientes' );
                            this.Controlador.Buscador.Filtros.Valores.Logistica = new Transporte( trp );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    }
                );
            }

        this.Valores.push( pendientes );

        let preparando: any = {
            Titulo: 'Preparando',
            Valor: this.Estadistica.Datos.preparando.total,
            Importe: this.Estadistica.Datos.preparando.importe,
            Hojas: [],
            Transportes: [],
            Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando' ); this.Controlador.Buscador.Buscar( 1 ); },
            Opciones: [
                {
                    Titulo: 'Facturados',
                    Valor: this.Estadistica.Datos.preparando.detalles.facturados,
                    Problema: this.Estadistica.Datos.preparando.detalles.facturados > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'facturados' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'No Facturados',
                    Valor: this.Estadistica.Datos.preparando.detalles.no_facturados,
                    Problema: this.Estadistica.Datos.preparando.detalles.no_facturados > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'no_facturados' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Demorados',
                    Valor: this.Estadistica.Datos.preparando.detalles.demorados,
                    Problema: this.Estadistica.Datos.preparando.detalles.demorados > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-demorados' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Despachar hoy',
                    Valor: this.Estadistica.Datos.preparando.detalles['despachar-hoy'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-despachar-hoy' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envio no acordado',
                    Valor: this.Estadistica.Datos.preparando.detalles['envio-no-acordado'],
                    Problema: this.Estadistica.Datos.preparando.detalles['envio-no-acordado'] > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-envio-no-acordado' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'MercadoEnvios',
                    Valor: this.Estadistica.Datos.preparando.detalles['mercado-envios'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-mercado-envios' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'MercadoEnvios Flex',
                    Valor: this.Estadistica.Datos.preparando.detalles['mercado-envios-flex'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-mercado-envios-flex' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envio gratis',
                    Valor: this.Estadistica.Datos.preparando.detalles['envio-gratis'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-envio-gratis' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Envios propios',
                    Valor: this.Estadistica.Datos.preparando.detalles['envio-propio'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-envio-propio' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Contraentregas',
                    Valor: this.Estadistica.Datos.preparando.detalles['contra-entrega'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-contra-entrega' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
                {
                    Titulo: 'Retira cliente',
                    Valor: this.Estadistica.Datos.preparando.detalles['retira-cliente'],
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-retira-cliente' ); this.Controlador.Buscador.Buscar( 1 ); },
                }
            ]
        };

        if ( this.Estadistica.Datos.preparando.hojas )
            for ( let trp of this.Estadistica.Datos.preparando.hojas ) {
                preparando.Hojas.push(
                    {
                        Hoja: 'Hoja nº ' + trp.hoja,
                        Valor: trp.total,
                        Accion: () => {
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando' );
                            this.Controlador.Buscador.Filtros.Valores.HojaPiso = trp.hoja;
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    }
                );
            }

        if ( this.Estadistica.Datos.preparando.transportes )
            for ( let trp of this.Estadistica.Datos.preparando.transportes ) {
                preparando.Transportes.push(
                    {
                        Empresa: new Transporte( trp ),
                        Valor: trp.total,
                        Accion: () => {
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando' );
                            this.Controlador.Buscador.Filtros.Valores.Logistica = new Transporte( trp );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    }
                );
            }

        this.Valores.push( preparando );

        let despachados: any = {
            Titulo: 'Despachados',
            Valor: this.Estadistica.Datos.despachados.total,
            Transportes: [],
            Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'despachados' ); this.Controlador.Buscador.Buscar( 1 ); },
            Opciones: [
                {
                    Titulo: 'Devueltos',
                    Valor: this.Estadistica.Datos.despachados.detalles.devueltos,
                    Problema: this.Estadistica.Datos.despachados.detalles.devueltos > 0,
                    Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'devueltos' ); this.Controlador.Buscador.Buscar( 1 ); },
                },
            ]
        };

        if ( this.Estadistica.Datos.despachados.transportes )
            for ( let trp of this.Estadistica.Datos.despachados.transportes ) {
                despachados.Transportes.push(
                    {
                        Empresa: new Transporte( trp ),
                        Valor: trp.total,
                        Accion: () => {
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'despachados' );
                            this.Controlador.Buscador.Filtros.Valores.Logistica = new Transporte( trp );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    }
                );
            }

        this.Valores.push( despachados );

        let finalizados = {
            Titulo: 'Finalizados',
            Valor: this.Estadistica.Datos.finalizados.total,
            Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'finalizados' ); this.Controlador.Buscador.Buscar( 1 ); },
        };
        this.Valores.push( finalizados );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

